/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Referral details from a third party.
 * @export
 * @interface RegisterCompanyDataThirdPartyReferralData
 */
export interface RegisterCompanyDataThirdPartyReferralData {
    /**
     * 
     * @type {string}
     * @memberof RegisterCompanyDataThirdPartyReferralData
     */
    referralCode?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterCompanyDataThirdPartyReferralData
     */
    platform?: RegisterCompanyDataThirdPartyReferralDataPlatformEnum;
}

/**
* @export
* @enum {string}
*/
export enum RegisterCompanyDataThirdPartyReferralDataPlatformEnum {
    PartnerStack = 'PartnerStack'
}


/**
 * Check if a given object implements the RegisterCompanyDataThirdPartyReferralData interface.
 */
export function instanceOfRegisterCompanyDataThirdPartyReferralData(value: object): value is RegisterCompanyDataThirdPartyReferralData {
    return true;
}

export function RegisterCompanyDataThirdPartyReferralDataFromJSON(json: any): RegisterCompanyDataThirdPartyReferralData {
    return RegisterCompanyDataThirdPartyReferralDataFromJSONTyped(json, false);
}

export function RegisterCompanyDataThirdPartyReferralDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterCompanyDataThirdPartyReferralData {
    if (json == null) {
        return json;
    }
    return {
        
        'referralCode': json['referralCode'] == null ? undefined : json['referralCode'],
        'platform': json['platform'] == null ? undefined : json['platform'],
    };
}

  export function RegisterCompanyDataThirdPartyReferralDataToJSON(json: any): RegisterCompanyDataThirdPartyReferralData {
      return RegisterCompanyDataThirdPartyReferralDataToJSONTyped(json, false);
  }

  export function RegisterCompanyDataThirdPartyReferralDataToJSONTyped(value?: RegisterCompanyDataThirdPartyReferralData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referralCode': value['referralCode'],
        'platform': value['platform'],
    };
}

